import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/App.css"; // Import CSS global
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import WhyChooseUs from "./components/WhyChooseUs"; // Komponen Mengapa Memilih Kami
import OurServicePage from "./pages/OurServicePage"; // Import halaman Our Service
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Works from "./pages/Works";
import VisionMissionPage from "./pages/VisionMissionPage";
import AboutPage from "./pages/AboutPage";
import BackgroundPage from "./pages/BackgroundPage";

// Register GSAP Plugins
gsap.registerPlugin(ScrollTrigger);

function App() {
    useEffect(() => {
        // Smooth Scroll Setup
        gsap.defaults({ duration: 1, ease: "power2.out" });
    }, []);

    return (
        <Router>
            <Navbar />
            <Routes>
                {/* Halaman Utama */}
                <Route
                    path="/"
                    element={
                        <>
                            <HeroSection />
                            <About />
                            <Services />
                            <WhyChooseUs /> {/* Tambahkan di sini */}
                            <Portfolio />
                            <Contact />
                            <Footer />
                        </>
                    }
                />

                {/* Halaman Baru */}
                <Route path="/works" element={<Works />} />
                <Route path="/vision-mission" element={<VisionMissionPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/background" element={<BackgroundPage />} />
                <Route path="/our-service" element={<OurServicePage />} /> {/* Tambahkan ini */}
            </Routes>
        </Router>
    );
}

export default App;